import { useEffect, useState } from "react";
import { admin } from "@/lib/api";
import { History } from "lucide-react";

const summary = (d) => (d ? `${d.name} · ${d.compcode}→${d.pcode} · ${(d.purc_types || []).join("/")} · ${d.active ? "Active" : "Inactive"}` : "—");

export function AutoApproveAuditLog({ refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    admin.autoRulesAudit().then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, [refreshKey]);

  return (
    <div className="bg-white border border-slate-200 rounded-sm p-4" data-testid="auto-rules-audit">
      <h3 className="text-sm font-semibold text-slate-700 inline-flex items-center gap-2 mb-2"><History size={14} /> Change log</h3>
      {rows.length === 0 ? <p className="text-xs text-slate-500">No changes yet.</p> : (
        <ul className="divide-y divide-slate-100 text-xs">
          {rows.map((a, i) => (
            <li key={i} className="py-2" data-testid={`auto-rules-audit-row-${i}`}>
              <span className="font-semibold uppercase text-cyan-800">{a.action}</span>
              <span className="text-slate-500"> · {a.by_name || a.by} · {new Date(a.at).toLocaleString("en-IN")}</span>
              {a.before && <div className="text-slate-500">Before: {summary(a.before)}</div>}
              {a.after && <div className="text-slate-700">After: {summary(a.after)}</div>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
